import type { EpgProgramme } from '@setplex/tria-api'
import type { HybridSearchPayloadWithPrice } from '~/shared/interfaces'

import { MediaTypes } from '@setplex/tria-api'
import { formatTimeRangeUnified } from '~/shared/helpers/date'

/**
 * Which card the search grid renders for an item. Catch-up channels reach the
 * client as ordinary `TV_CHANNEL` results carrying EPG data, so `contentType`
 * alone cannot tell them apart from Watch Now channels — the section does.
 */
export const SEARCH_CARD_KIND_CATCHUP = 'EPG_CATCHUP'

export type SearchCardKind =
  | typeof SEARCH_CARD_KIND_CATCHUP
  | MediaTypes
  | undefined

export function getSearchCardKind(
  item: HybridSearchPayloadWithPrice
): SearchCardKind {
  return item.section === 'CATCHUPS' &&
    item.contentType === MediaTypes.TV_CHANNEL &&
    item.programme != null
    ? SEARCH_CARD_KIND_CATCHUP
    : item.contentType
}

/**
 * "25 Apr, 7:30 PM - 9:00 PM" (12h) or "25 Apr, 19:30 - 21:00" (24h), taking
 * the clock format from the active date-fns locale (UI-2.8, UI-5.8).
 */
export function formatCatchupTimeLabel(
  programme: EpgProgramme | undefined
): string {
  const startMs = programme?.startMs
  const stopMs = programme?.stopMs

  if (
    startMs == null ||
    stopMs == null ||
    !Number.isFinite(startMs) ||
    !Number.isFinite(stopMs) ||
    stopMs <= startMs
  ) {
    return ''
  }

  return formatTimeRangeUnified(startMs, stopMs, { alwaysIncludeDate: true })
}
